module.exports = __webpack_public_path__ + "img/banner.3118d835.png";